import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StringUtilsService {
  constructor() {
  }

  jsonPropDict = {
    'sellerCode': 'Seller Code',
    'name': 'Name',
    'displayNm': 'Display Name',
    'address': 'Address',
    'reconPath': 'Recon Path',
    'username': 'User Name',
    'email': 'Email ID'
  }

  trim(str) {
    return str.replace(/^\s+|\s+$/gm, '');
  }

  roundNoToTwoDecimal(num) {
    return parseFloat((Math.round(num * 100) / 100).toFixed(2));
  }

  formatNumberAsCurrency(num) {
    if (num === '#NA') {
      return num;
    }
    if (!num) {
      num = 0;
    }
    num = (Math.round(num * 100) / 100).toFixed(2);
    const formatNum = (numToFormat) => numToFormat.replace(/(\d)(?=(\d\d)+\d$)/g, '$1,');
    const numStr = num.toString().split('.');
    return numStr.length > 1 ? `${formatNum(numStr[0])}.${numStr[1]}` : `${formatNum(numStr[0])}.00`;
  }

  formatNumberAsCurrencyRound(num) {
    if (num === '#NA') {
      return num;
    }
    if (!num) {
      num = 0;
    }
    num = (Math.round(num));
    const formatNum = (numToFormat) => numToFormat.replace(/(\d)(?=(\d\d)+\d$)/g, '$1,');
    const numStr = num.toString().split('.');
    return numStr.length > 1 ? `${formatNum(numStr[0])}.${numStr[1]}` : `${formatNum(numStr[0])}`;
  }

  formatNumberAsCurrencyWithLocale(num, locale, currency) {
    const currFormat = Intl.NumberFormat(locale, {
      style: "currency",
      currency: currency,
    });
    return currFormat.format(num || 0);
  }

  getEllipsisText(str, len = 20) {
    let retStr = str || '';
    if (retStr.length > len) {
      retStr = `${retStr.substring(0, len - 3)}...`;
    }
    return retStr;
  }

  replaceAllSpace(str) {
    return str.replace(new RegExp('[^a-zA-Z0-9]', 'g'), '');
  }

  getTitleCase(val) {
    return `${val.substr(0, 1).toUpperCase()}${val.substr(1, val.length - 1).toLowerCase()}`
  }

  getJSONPropDescription(val) {
    return this.jsonPropDict[val] || val;
  }

  replaceSpecialChars(str) {
    const htmlEntities = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&apos;"
    };
    //str = str.replaceAll('&amp;','&');
    str = str.replace(/([&<>\"'])/g, match => htmlEntities[match]);
    return str.replace(/[^a-z\d\s]+/gi, '');
  }

  // str - This is test data for {{buyerName}}
  // templateData - {buyerName: '123'}
  // Output This is test data for 123
  getStringWithTemplateValues(str, templateData = {}) {
    Object.keys(templateData).forEach((key) => {
      str = str.replace(new RegExp(`\\{\\{\\s*${key}\\s*\\}\\}`, 'g'), templateData[key]);
    });
    return str;
  }

}
